import React, { FC } from 'react'
import Modal, { IModalProps } from 'components/Modal';
import { useHistory } from 'react-router-dom';

interface IPtCountErrorModal extends IModalProps {
  onClose?: ( ) => void;
};

const PtCountErrorModal: FC<IPtCountErrorModal> = ({dim = true, open=false, frame=true, onClose=()=>{}}) => {
  const history = useHistory();
  return (
    <Modal
      dim={dim}
      open={open}
      frame={frame}
    >
      <div>
        최대 응시 가능횟수를 초과하여 재응시가 제한됩니다.
      </div>
      <button
        className='btn-cta'
        onClick={()=>{
          document.location.reload();
          onClose();
        }}
      >
        확인
      </button>
    </Modal>
  );
};

export default PtCountErrorModal;